import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { Table } from "common/data/table";
import { docEntityIsIsolatable } from "doc/docEntityIsolatable";

/**
 * Determines if a source entity should be generated based on the isolated entity.
 * When an entity is isolated, only entities that are in the isolated entity should be generated.
 * When no entity is isolated, only entities that are not in any isolatable entities should be generated.
 */
export function shouldGenerateEntity(
  entityId: string,
  idToParents: Table<readonly string[]>,
  isolatedEntity: DocEntityHandle | undefined,
): boolean {
  const entityParentIds = idToParents[entityId] || [];

  if (isolatedEntity && docEntityIsIsolatable(isolatedEntity)) {
    switch (isolatedEntity.type) {
      case "COMPONENT": {
        // Component mode: only generate if entity is in the isolated entity.
        return entityParentIds.includes(isolatedEntity.id);
      }
      default: {
        return false;
      }
    }
  } else {
    // Default mode: only generate if the entity is not a child of any isolable entity.
    return !entityParentIds.length;
  }
}
